/**
 *  @fileOverview search module
 *
 *  @author Andras Muk <andras.muk@possible.com>
 */

import forEach from 'lodash/forEach';
import detectIt from 'detect-it';

class Search {
  constructor() {
    this.initialGlossaryContent = '';
  }

  init() {
    this.initDOMElements();
    if (this.searchForm !== null) {
      this.initBindings();
    }
  }

  initDOMElements() {
    this.searchForm = document.body.querySelector('[data-search]');
    this.searchSection = document.body.querySelector('[data-content-search]');
    this.searchAriaResult = document.body.querySelector('[data-search-aria-result]');
    if (this.searchForm !== null) {
      this.searchField = this.searchForm.querySelector('[data-search-input]');
      this.resetButton = this.searchForm.querySelector('[data-search-reset]');
    }
    if (this.searchSection !== null) {
      this.rows = this.searchSection.querySelectorAll('.row');
    }
    this.noResultSection = document.body.querySelector('[data-search-noresults]');
    if (this.noResultSection !== null) {
      this.searchText = this.noResultSection.querySelector('span');
    }
  }

  initBindings() {
    const content = this.getContent(this.rows);

    this.searchField.addEventListener('keydown', (e) => {
      if ((e.key === 'Enter' || e.keyCode === 13) && detectIt.deviceType !== 'mouseOnly') {
        this.searchField.blur();
      }

      if (e.keyCode === 13) {
        e.stopPropagation();
        e.preventDefault();
      }
    });

    this.searchField.addEventListener('keyup', (e) => {
      const fieldValue = e.currentTarget.value;

      if (fieldValue.length >= 3) {
        this.searchInArray(content, fieldValue);
      } else {
        this.resetList();
      }
    });

    this.searchField.addEventListener('blur', () => {
      this.setFilledStatus(this.searchField);
    });

    this.resetButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.resetList();
      this.clearSearch();
      this.setFilledStatus(this.searchField);
    });
  }

  getContent(rows) {
    const glossaryContent = [];

    forEach(rows, (element) => {
      glossaryContent.push(element.innerHTML);
      this.initialGlossaryContent += `<div class="row row--no-margin" aria-live="polite">${element.innerHTML}</div>`;
    });

    return glossaryContent;
  }

  setFilledStatus(input) {
    if (input.value.length > 0) {
      input.classList.add('filled');
    } else {
      input.classList.remove('filled');
    }
  }

  searchInArray(array, text) {
    this.updateList(array.filter(item => item.toLowerCase().includes(text.toLowerCase())), text);
  }

  updateList(list, text) {
    let markup = '';

    if (list.length === 0) {
      markup = '';
      if (this.noResultSection !== null) {
        this.noResultSection.classList.remove('grid--hidden');
        this.noResultSection.setAttribute('aria-live', 'polite');
      }
      this.searchText.innerHTML = text;
    } else {
      forEach(list, (element) => {
        markup += `<div class="row row--no-margin" aria-live="polite">${element}</div>`;
      });
      this.noResultSection.classList.add('grid--hidden');
      this.noResultSection.removeAttribute('aria-live');
      this.searchText.innerHTML = '';
    }

    if (this.searchAriaResult !== null) {
      this.searchAriaResult.setAttribute('aria-live', 'off');
      this.searchAriaResult.setAttribute('role', 'region');
      this.searchAriaResult.innerHTML = 'Searching...';
      window.clearTimeout(this.timeoutTid);
      this.timeoutTid = window.setTimeout(() => {
        if (list.length === 0) {
          this.searchAriaResult.setAttribute('role', 'alert');
          this.searchAriaResult.setAttribute('aria-live', 'assertive');
          this.searchAriaResult.innerHTML = 'No results found.';
        } else {
          this.searchAriaResult.setAttribute('role', 'alert');
          this.searchAriaResult.setAttribute('aria-live', 'assertive');
          this.searchAriaResult.innerHTML = `Search found ${list.length} results.`;
        }
      }, 1000);
    }

    this.searchSection.innerHTML = markup;
  }

  resetList() {
    this.searchSection.innerHTML = this.initialGlossaryContent;
    if (this.noResultSection !== null) {
      this.noResultSection.classList.add('grid--hidden');
      this.noResultSection.removeAttribute('aria-live');
    }
  }

  clearSearch() {
    this.searchField.value = '';
  }
}

export const search = new Search();



// WEBPACK FOOTER //
// ./src/js/modules/search.js